/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo } from 'react';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { FaPrint } from 'react-icons/fa';
import AddIcon from '@mui/icons-material/Add';
import {
  InputAdornment,
  Button,
  Box,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import RelatorioViagens from '../RelatorioViagem';

import axios from '../../services/axios';
import { ContainerGrid, Title, SubTitle } from '../../styles/GlobalStyles';
import DataTableView from '../../components/DataTableView';
import Loading from '../../components/Loading';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import NumberFormatCustom3 from '../../utils/NumberFormatCustom3';
import NumberFormatKm from '../../utils/NumberFormatKm';

dayjs.locale('pt-br');

export default function ControleViagens() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [descricao, setDescricao] = useState('');
  const [saida, setSaida] = useState('');
  const [lancamento, setLancamento] = useState('');
  const [retorno, setRetorno] = useState('');
  const [kmsaida, setKmSaida] = useState('');
  const [kmretorno, setKmRetorno] = useState('');
  const [imgsaida, setImgSaida] = useState('');
  const [imgretorno, setImgRetorno] = useState('');
  const [consumo, setConsumo] = useState('');
  const [peso, setPeso] = useState('');
  const [funcionario, setFuncionario] = useState('');
  const [motorista, setMotorista] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [veiculo, setVeiculo] = useState('');
  const [carreta, setCarreta] = useState('');
  const [receitas, setReceitas] = useState([]);
  const [despesas, setDespesas] = useState([]);
  const [adiantamentos, setAdiantamentos] = useState([]);
  const [flag_acerto, setFlagAcerto] = useState(false);

  const [totaladiantamentos, setTotalAdiantamentos] = useState('');
  const [totalreceitas, setTotalReceitas] = useState('');
  const [totaldespesas, setTotalDespesas] = useState('');
  const [totalcomissao, setTotalComissao] = useState('');

  const [totalsaldoreceber, setTotalSaldoReceber] = useState('');
  const [totaldespesasmotorista, setTotalDespesasMotorista] = useState('');

  const [vlicms, setVlIcms] = useState('');
  const [vlpis, setVlPis] = useState('');
  const [vlcofins, setVlCofins] = useState('');
  const [pericms, setPerIcms] = useState('');
  const [perpis, setPerPis] = useState('');
  const [percofins, setPerCofins] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [isImgSaidaModalOpen, setIsImgSaidaModalOpen] = useState(false);
  const [isImgRetornoModalOpen, setIsImgRetornoModalOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleOpen = (i) => {
    setSelectedId(i);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedId('');
  };

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/viagens/${id}`);
      let children;
      children = get(data, 'Funcionario.nome', '');
      setFuncionario(children);
      children = get(data, 'Motoristum.nome', '');
      setMotorista(children);
      children = get(data, 'Empresa.nome', '');
      setEmpresa(children);
      children = get(data, 'Veiculo.placa', '');
      setVeiculo(children);
      children = get(data, 'Carretum.placa', '');
      setCarreta(children);
      children = get(data, 'Receita', '');
      setReceitas(children);
      children = get(data, 'Despesas', '');
      setDespesas(children);
      children = get(data, 'Adiantamentos', '');
      setAdiantamentos(children);
      setDescricao(data.descricao);
      setLancamento(dayjs(data.lancamento));
      setSaida(dayjs(data.saida));
      setRetorno(dayjs(data.retorno));
      setKmSaida(data.kmsaida);
      setKmRetorno(data.kmretorno);
      setConsumo(data.consumo);
      setPeso(data.peso);
      setFlagAcerto(data.flag_acerto);

      if (
        data.imgsaida &&
        typeof data.imgsaida === 'string' &&
        data.imgsaida.length > 50
      ) {
        setImgSaida(data.imgsaida);
      } else {
        setImgSaida(null);
      }
      if (
        data.imgretorno &&
        typeof data.imgretorno === 'string' &&
        data.imgretorno.length > 50
      ) {
        setImgRetorno(data.imgretorno);
      } else {
        setImgRetorno(null);
      }

      setTotalAdiantamentos(data.totaladiantamentos);
      setTotalReceitas(data.totalreceitas);
      setTotalDespesas(data.totaldespesas);
      setTotalComissao(data.totalcomissao);

      /* const despesasMotorista = despesas
        .filter((despesa) => despesa.TipoDespesa.flag_motorista === true)
        .reduce((total, despesa) => total + despesa.valor, 0);

      setTotalDespesasMotorista(despesasMotorista);

      setTotalSaldoReceber(
        data.totalcomissao + despesasMotorista - data.totaladiantamentos
      ); */

      setVlIcms(data.vlicms);
      setVlPis(data.vlpis);
      setVlCofins(data.vlcofins);

      setPerIcms(data.pericms);
      setPerPis(data.perpis);
      setPerCofins(data.percofins);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate('/viagens');
    }
  }

  useEffect(() => {
    if (!id) return;
    getData();
  }, [updateFlag, id]);

  useEffect(() => {
    const despesasMotorista = despesas
      .filter((despesa) => despesa.TipoDespesa.flag_motorista === true)
      .reduce((total, despesa) => total + despesa.valor, 0);

    setTotalDespesasMotorista(despesasMotorista);

    // Atualizar o saldo a receber
    setTotalSaldoReceber(
      totalcomissao + despesasMotorista - totaladiantamentos
    );
  }, [despesas, totalcomissao, totaladiantamentos]);

  const handleAcerto = async (e) => {
    try {
      if (id) {
        await axios.put(`/viagens/${id}`, {
          flag_acerto: e,
        });
      }
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else {
        toast.error(`Ocorreu um erro ao alterar registro.`);
      }
    }
    getData();
  };

  const handleTributos = async () => {
    try {
      if (id) {
        await axios.put(`/${'viagens'}/${id}`, {
          vlicms,
          vlpis,
          vlcofins,
          pericms,
          perpis,
          percofins,
        });
        toast.success(`Alterado com sucesso!`);
      }
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else {
        toast.error(`Ocorreu um erro ao alterar registro.`);
      }
    }
    getData();
  };

  const columnsA = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'descricao',
        header: 'Descrição',
        size: 80,
      },
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Valor',
        size: 80,
      },
    ],
    []
  );

  const columnsR = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'nrcoleta',
        header: 'Ordem Coleta',
        size: 80,
      },
      {
        accessorKey: 'Cliente.nome',
        header: 'Cliente',
        size: 80,
      },
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Valor',
        size: 80,
      },
      {
        accessorKey: 'LocalSaida.municipio',
        header: 'Local Saída',
        size: 80,
      },
      {
        accessorKey: 'LocalDestino.municipio',
        header: 'Local Destino',
        size: 80,
      },
    ],
    []
  );

  const columnsD = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'flag_checked',
        header: 'Conferido',
        accessorFn: (row) => (get(row, 'flag_checked', 0) ? 'Sim' : 'Não'),
        size: 80,
        Cell: ({ cell }) => {
          const value = cell.getValue(); // 'Sim' ou 'Não'
          const color = value === 'Sim' ? 'green' : 'red'; // Define a cor da fonte
          return (
            <div
              style={{
                color,
                textAlign: 'center', // Centraliza o texto horizontalmente
                display: 'flex',
                justifyContent: 'center', // Centraliza o texto horizontalmente dentro do div
                alignItems: 'center', // Centraliza verticalmente se a célula for alta
                height: '100%', // Garante que o texto esteja centralizado verticalmente
              }}
            >
              {value}
            </div>
          );
        },
      },
      /* {
        accessorKey: 'descricao',
        header: 'Descrição1',
        size: 80,
      }, */
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Valor',
        size: 80,
      },
      {
        accessorKey: 'TipoDespesa.nome',
        header: 'Tipo Despesa',
        size: 80,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>
        {id
          ? `Registro de Viagem Nr. ${id}`
          : 'Registro de Viagem não Localizado'}
      </Title>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <div>
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={() => handleOpen(id)}
          >
            <FaPrint size={24} />
          </Button>
          {selectedId !== null && (
            <RelatorioViagens
              id={selectedId}
              open={open}
              onClose={handleClose}
            />
          )}
        </div>

        <FormControlLabel
          control={
            <Checkbox
              checked={flag_acerto}
              onChange={(e) => handleAcerto(e.target.checked)}
              size="small"
            />
          }
          label="Acerto realizado com o Motorista"
        />
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/viagens`)}
        >
          Fechar
        </Button>
      </Box>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                disabled
                label="Data Lançamento"
                variant="filled"
                size="small"
                value={lancamento}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={funcionario}
              label="Funcionário"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                disabled
                label="Data Saída"
                variant="filled"
                size="small"
                value={saida}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                disabled
                label="Data Retorno"
                variant="filled"
                size="small"
                value={retorno}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                value={kmsaida}
                label="Km Saída"
                InputProps={{
                  inputComponent: NumberFormatKm,
                  startAdornment: (
                    <InputAdornment position="start">Km</InputAdornment>
                  ),
                  readOnly: true,
                }}
                variant="filled"
                size="small"
                sx={{ flex: 1 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setIsImgSaidaModalOpen(true)} // Função para abrir o modal
              >
                Hodômetro
              </Button>
            </Box>

            {/* Modal para exibir a imagem */}
            <Dialog
              open={isImgSaidaModalOpen}
              onClose={() => setIsImgSaidaModalOpen(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Imagem Hodômetro de Saída</DialogTitle>
              <DialogContent>
                {imgsaida ? (
                  <img
                    src={
                      typeof imgsaida === 'string'
                        ? imgsaida
                        : URL.createObjectURL(imgsaida)
                    }
                    alt="Imagem Hodômetro de Saída"
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                    }}
                  />
                ) : (
                  <p>Imagem Hodômetro não disponível</p>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setIsImgSaidaModalOpen(false)}
                  color="primary"
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                value={kmretorno}
                label="Km Retorno"
                InputProps={{
                  inputComponent: NumberFormatKm,
                  startAdornment: (
                    <InputAdornment position="start">Km</InputAdornment>
                  ),
                  readOnly: true,
                }}
                variant="filled"
                size="small"
                sx={{ flex: 1 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setIsImgRetornoModalOpen(true)} // Função para abrir o modal
              >
                Hodômetro
              </Button>
            </Box>

            {/* Modal para exibir a imagem */}
            <Dialog
              open={isImgRetornoModalOpen}
              onClose={() => setIsImgRetornoModalOpen(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Imagem Hodômetro de Retorno</DialogTitle>
              <DialogContent>
                {imgretorno ? (
                  <img
                    src={
                      typeof imgretorno === 'string'
                        ? imgretorno
                        : URL.createObjectURL(imgretorno)
                    }
                    alt="Imagem de Retorno"
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                    }}
                  />
                ) : (
                  <p>Imagem não disponível</p>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setIsImgRetornoModalOpen(false)}
                  color="primary"
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              value={peso}
              label="Peso"
              InputProps={{
                inputComponent: NumberFormatCustom3,
                startAdornment: (
                  <InputAdornment position="start">T</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={consumo}
              label="Consumo"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">L</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={motorista}
              label="Motorista"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={veiculo}
              label="Veículo"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={carreta}
              label="Carreta"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              value={empresa}
              label="Empresa"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              value={descricao}
              label="Descrição"
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          border: '1px solid black',
          '& .MuiTextField-root': {
            m: 1,
            width: { xs: '85%', sm: '85%' },
          },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <TextField
              value={totalreceitas}
              label="Total Receitas"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={totaldespesas}
              label="Total Despesas"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={totalcomissao}
              label="Total Comissão"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={totaldespesasmotorista}
              label="Total Despesas Pagas Pelo Motorista"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={totaladiantamentos}
              label="Total Adiantamento"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={totalsaldoreceber}
              label="Saldo a Receber"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        onBlur={(event) => {
          // Check if the related target (next focused element) is outside the Box
          if (!event.currentTarget.contains(event.relatedTarget)) {
            handleTributos();
          }
        }}
        tabIndex={-1} // Ensures the Box itself is focusable
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          border: '1px solid black',
          '& .MuiTextField-root': {
            m: 1,
            width: { xs: '85%', sm: '85%' },
          },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={2}>
            <TextField
              value={pericms}
              label="% ICMS"
              size="small"
              onChange={(e) => setPerIcms(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">%</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={vlicms}
              label="Valor ICMS"
              size="small"
              onChange={(e) => setVlIcms(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={perpis}
              label="% PIS"
              size="small"
              onChange={(e) => setPerPis(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">%</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={vlpis}
              label="Valor PIS"
              size="small"
              onChange={(e) => setVlPis(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={percofins}
              label="% COFINS"
              size="small"
              onChange={(e) => setPerCofins(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">%</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={vlcofins}
              label="Valor COFINS"
              size="small"
              onChange={(e) => setVlCofins(e.target.value)}
              sx={{
                backgroundColor: 'yellow',
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} sm={4}>
          <SubTitle>Adiantamentos</SubTitle>
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={() => navigate(`/adiantamento/${id}`)}
          >
            <AddIcon size={24} />
          </Button>
          <div>
            <DataTableView
              columns={columnsA}
              data={adiantamentos}
              tableData="adiantamentos"
              tableRoute={`adiantamento/${id}`}
              tableRoute2="adiantamento"
              onUpdate={() => setUpdateFlag((prev) => !prev)}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <SubTitle>Receitas</SubTitle>
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={() => navigate(`/receita/${id}`)}
          >
            <AddIcon size={24} />
          </Button>
          <div>
            <DataTableView
              columns={columnsR}
              data={receitas}
              tableData="receitas"
              tableRoute={`receita/${id}`}
              tableRoute2="receita"
              onUpdate={() => setUpdateFlag((prev) => !prev)}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <SubTitle>Despesas</SubTitle>
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={() => navigate(`/despesa/${id}`)}
          >
            <AddIcon size={24} />
          </Button>
          <div>
            <DataTableView
              columns={columnsD}
              data={despesas}
              tableData="despesas"
              tableRoute={`despesa/${id}`}
              tableRoute2="despesa"
              onUpdate={() => setUpdateFlag((prev) => !prev)}
            />
          </div>
        </Grid>
      </Grid>
    </ContainerGrid>
  );
}
